import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export default {
  data: function data() {
    return {
      dialog: {
        visible: false,
        showClose: false,
        top: '100px',
        width: '400px',
        customClass: 'el-dialog__no-top-border',
        appendToBody: true
      }
    };
  },
  computed: {
    // 表单容器的标题
    title: function title() {
      return this.switchByMode('create', 'edit', 'detail');
    }
  },
  methods: {
    /**
     * @description vNode 模态框
     * @param {VNode} content 内容
     */
    vNodeDialog: function vNodeDialog(content) {
      var h = this.$createElement;
      var node = h("el-dialog", {
        "attrs": _objectSpread(_objectSpread({}, this.dialog), {}, {
          "title": this.title
        }),
        "on": {
          "close": this.cancle
        }
      }, [content]);
      return node;
    },

    /**
     * @description 打开面板
     */
    open: function open() {
      var _this = this;

      this.dialog.visible = true;
      this.$nextTick(function () {
        return _this.clearValidate();
      });
    },

    /**
     * @description 关闭面板
     */
    cancle: function cancle() {
      this.clearValidate();
      this.dialog.visible = false;
    },

    /**
     * @description 清空表单校验
     */
    clearValidate: function clearValidate() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.form && _this2.$refs.form.clearValidate();
      });
    }
  }
};